module.exports = __webpack_public_path__ + "img/aqy.65ea1ec5.jpg";